var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transactionlist',{attrs:{"api":"1722"}})
}
var staticRenderFns = []

export { render, staticRenderFns }